import axios from "axios";
import qs from "qs";
//import pkceChallenge from "pkce-challenge";
import pkceChallenge from "../utils/pkchallenge"
import { useNavigate } from "react-router-dom";

const { REACT_APP_DEV } = process.env;

const authServer = axios.create({
  baseURL: REACT_APP_DEV === "TRUE"?"http://127.0.0.1:8085":"https://login.sigas.org.br",
});

authServer.interceptors.response.use(undefined, async (error) => {
  if (error?.response?.status === 401) {
    AuthService.imperativelySendToLogout();
  } else if (error?.response?.status === 400) {
    AuthService.imperativelySendToLogout();
  }

  return Promise.reject(error);
});

export interface OAuthAuthorizationTokenResponse {
  access_token: string;
  refresh_token: string;
  //  expires_in: number;
  //  scope: string;
}

export default class AuthService {

  public static async imperativelySendToInitialPage(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const navigate = useNavigate();

        navigate("/"); 

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }  

  public static imperativelySendToLogout() {
    window.localStorage.clear();
    window.location.href = REACT_APP_DEV === "TRUE"?`http://127.0.0.1:8085/logout?returnTo=http://kubernetes.docker.internal:3000`:`https://login.sigas.org.br/logout?returnTo=https://www.acerteiquestoes.com.br`;
  }

  public static logoutAndRedirect = () => {
    AuthService.removeToken();
    // Sem isto o perfil em cache sobrevive à troca de usuário na mesma aba, e
    // o próximo login nasceria com a semente do anterior — ver useProfileStore.
    AuthService.removeUserProfile();
    window.location.href = "/login" // força redirecionamento
  }

  public static async getNewToken(config: {
    code: string;
    codeVerifier: string;
    redirectUri: string;
  }) {
    const data = qs.stringify({
      grant_type: "authorization_code",
      code_verifier: config.codeVerifier,
      code: config.code,
      redirect_uri: config.redirectUri,
    });
    const { REACT_APP_SSO_USER, REACT_APP_SSO_PASSWORD } = process.env;
    const encodedData = qs.stringify(data);

    return authServer
      .post<OAuthAuthorizationTokenResponse>("/oauth2/token", encodedData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        auth: {
          username: REACT_APP_SSO_USER!,
          password: REACT_APP_SSO_PASSWORD!,
        },
      })
      .then((res) => res.data);
  }

  public static async getFirstAccessTokens(config: {
    code: string;
    codeVerifier: string;
    redirectUri: string;
  }) {
    const data = {
      grant_type: "authorization_code",
      code_verifier: config.codeVerifier,
      code: config.code,
      redirect_uri: config.redirectUri,
    };

    const encodedData = qs.stringify(data);
    const { REACT_APP_SSO_USER, REACT_APP_SSO_PASSWORD } = process.env;

    this.setFirstTime("NO");

    const authServerLocal = axios.create({
      baseURL: REACT_APP_DEV === "TRUE"?"http://127.0.0.1:8085":"https://login.sigas.org.br",
    });

    return authServerLocal
      .post<OAuthAuthorizationTokenResponse>("/oauth2/token", encodedData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        auth: {
          username: REACT_APP_SSO_USER!,
          password: REACT_APP_SSO_PASSWORD!,
        },
      })
      .then((res) => res.data);
  }

  public static async imperativelySendToLoginScreen(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const navigate = useNavigate();

        navigate("/login"); 

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  public static removeToken() {
    return window.localStorage.removeItem("accessToken");
  }

  public static getAccessToken() {
    return window.localStorage.getItem("accessToken");
  }

  public static setAccessToken(token: string) {
    return window.localStorage.setItem("accessToken", token);
  }

  public static getUserProfile() {
    return window.localStorage.getItem("userProfile");
  }

  public static setUserProfile(profile: string) {
    return window.localStorage.setItem("userProfile", profile);
  }

  public static removeUserProfile() {
    return window.localStorage.removeItem("userProfile");
  }

  public static getRefreshToken() {
    return window.localStorage.getItem("refreshToken");
  }

  public static setRefreshToken(token: string) {
    return window.localStorage.setItem("refreshToken", token);
  }

  public static getCodeVerifier() {
    return window.localStorage.getItem("codeVerifier");
  }

  public static setCodeVerifier(getCodeVerifier: string) {
    return window.localStorage.setItem("codeVerifier", getCodeVerifier);
  }

  public static getCodeChallenge() {
    return window.localStorage.getItem("codeChallenge");
  }

  public static setCodeChallenge(getCodeChallenge: string) {
    return window.localStorage.setItem("codeChallenge", getCodeChallenge);
  }

  public static getFirstTime() {
    return window.localStorage.getItem("firstTime");
  }

  public static setFirstTime(getFirstTime: string) {
    return window.localStorage.setItem("firstTime", getFirstTime);
  }
}
